import { AlertTriangle, ArrowLeft, Home } from "lucide-react";
import { Link } from "react-router-dom";

export const ListingRouteErrorState = ({ homePath, listingsPath }) => (
  <section className="section-shell py-12" data-testid="listing-route-error-state">
    <div className="mx-auto max-w-4xl rounded-[32px] border border-[#001935]/10 bg-white/90 p-8 shadow-[0_24px_70px_rgba(0,25,53,0.08)] md:p-10">
      <div className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-amber-50 px-4 py-2 text-[11px] font-bold uppercase tracking-[0.18em] text-amber-800" data-testid="listing-route-error-badge">
        <AlertTriangle className="h-4 w-4" /> Listing route recovered
      </div>
      <h1 className="mt-5 font-[Cormorant_Garamond,serif] text-4xl font-bold text-[#001935] sm:text-5xl" data-testid="listing-route-error-heading">
        We recovered this page before it could crash your session.
      </h1>
      <p className="mt-4 max-w-2xl text-sm leading-8 text-[#42566f] sm:text-base" data-testid="listing-route-error-copy">
        Something unexpected happened while rendering this listing. You can safely head back to the portfolio or return to the home page.
      </p>
      <div className="mt-8 flex flex-wrap gap-3" data-testid="listing-route-error-actions">
        <Link className="gold-button !px-5 !py-3" data-testid="listing-route-error-listings-link" to={listingsPath}>
          <ArrowLeft className="mr-2 h-4 w-4" /> Back to Listings
        </Link>
        <Link className="outline-button" data-testid="listing-route-error-home-link" to={homePath}>
          <Home className="mr-2 h-4 w-4" /> Home
        </Link>
      </div>
    </div>
  </section>
);

export default ListingRouteErrorState;